import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export const EmailVerified = () => {
  return (
    <div className="section-container py-16">
      <div className="max-w-xl mx-auto bg-white/5 border border-white/10 p-8">
        <h1 className="font-['Playfair_Display'] text-3xl text-white mb-3">
          Email verificado ✅
        </h1>
        <p className="text-white/60 mb-6">
          Tu cuenta ya está activa. Ya puedes iniciar sesión.
        </p>

        <Link to="/login">
          <Button className="btn-primary w-full">Iniciar sesión</Button>
        </Link>
      </div>
    </div>
  );
};
